import * as _ from 'lodash/fp';

export enum DetailTabsList {
    eventsTab = 'Events',
    eventSummaryTab = 'Event Summary',
}

export const CDetailTabs = _.values(DetailTabsList);
